import React from 'react';
import { getBlogData } from '../ListPresentationV1/utils';
import { BlogComponent } from '.';
import { useListPresentationContextData } from '../ListPresentationV1/context/ListPresentationContext';
import { useSSRSelector } from 'src/redux';
import { RootState } from 'src/redux/reducers';

export default function BlogWidgetRenderer() {
  const data = useListPresentationContextData();
  const props = data.props;
  const { blogData } = useSSRSelector((state: RootState) => ({
    blogData: state?.additionalPagesReducer?.newBlogList || props?.blogData,
  }));

  const simplifiedBlogData = getBlogData(blogData);
  const blogDataLength = simplifiedBlogData?.length;
  const updatedBlogData = props?.isBlogListingPage
    ? simplifiedBlogData?.slice(1, blogDataLength)
    : simplifiedBlogData;

  return updatedBlogData?.map((columnData, index) => (
    <BlogComponent key={index} index={index} columnData={columnData} />
  ));
}
